
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { AthleteReportCategory } from '@/models'
import { ColorMixin, StringsMixin } from '@/mixins';

@Component
export default class ScoreChip extends Mixins(StringsMixin, ColorMixin){
	@Prop() category: AthleteReportCategory;
	@Prop() score: number;
	@Prop() name: string;
	@Prop({type: Boolean}) small;
	@Prop({type: Boolean}) large;
	@Prop({type: String}) tooltip: string;
	@Prop({default: 0}) precision: number;
	@Prop({default: 1}) tooltipPrecision: number;
	@Prop({default: 1}) px: number;

	get ChipClass(): string {
		return `px-${this.px}`
	}

	get CategoryScoreNumber(): number {
		if( this.IsNotEmpty(this.category?.score) ) return Number(this.category.score);
		if( this.IsNotEmpty(this.score) ) return this.score;
		return undefined;
	}

	get CategoryScore(): string {
		if( this.IsEmpty(this.CategoryScoreNumber) ) return '--';
		if( this.CategoryScoreNumber > 99 ) return '99+'
		return this.CategoryScoreNumber.toFixed(this.precision);
	}

	get CategoryScoreTooltip(): string {
		if( this.IsEmpty(this.CategoryScoreNumber) ) return '--';
		if( this.CategoryScoreNumber > 99 ) return '99+'
		return this.CategoryScoreNumber.toFixed(this.tooltipPrecision);
	}

	get ToolTipColor(): string {
		if( this.IsEmpty(this.CategoryScoreNumber) ) return 'white';

		return this.ScoutingScoreColor(this.CategoryScoreNumber);
	}

	get ToolTip(): string {
		if( this.IsNotEmpty(this.tooltip) ) return this.tooltip;
		if( this.IsNotEmpty(this.category) ) return `${this.category.name}: ${this.CategoryScoreTooltip}`;
		if( this.IsNotEmpty(this.name) && this.IsNotEmpty(this.score) ) return `${this.capitalizeCamelCase(this.name)}: ${this.score}`;
		return 'Rating not available';
	}
}
